import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const searchSendReceptData = (headers, params) => {
    let query = buildQuery(params, []);
    if (params.filters.serviceCode?.value) {
        query += `&serviceCode=${params.filters.serviceCode.value?.trim()}`;
    }
    // else {
    //     query += `&serviceCode=GUI-KQ-HS-CO-SINH-TRAC-SANG-DDS`;
    // }
    if (params.filters.idNumber?.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.requestType?.value) {
        query += `&requestType=${params.filters.requestType.value?.trim()}`;
    }
    if (params.filters.unitId?.value) {
        query += `&unitId=${params.filters.unitId.value}`;
    }
    if (params.filters.fromDate?.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    // else {
    //     query += `&fromDate=2021-01-01`;
    // }
    if (params.filters.toDate?.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    // else {
    //     query += "&toDate=2022-10-07";
    // }
    if (params.filters.maVung?.value) {
        query += `&maVung=${params.filters.maVung?.value}`;
    }

    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/send-receipt-data${query}`, {
        headers,
    });
};

export const getListServiceCode = (headers, maVung) => {
    const query = `?maVung=${maVung}`;
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/send-receipt-data/listServiceCode${query}`, {
        headers,
    });
};

export const getRequestTypesByServiceCOde = (headers, serviceCode) => {
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/send-receipt-data/listServiceCode/${serviceCode}`, {
        headers,
    });
};

export const getContent = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/send-receipt-data/getContent/${id}`, {
        headers,
    });
};
